import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../css/main.scss";
import { siteConfig } from "../config/siteConfig";

const homeLinks = [
  { label: "Collections", to: "/shop", image: "/img/material-detail.jpg", tone: "burgundy" },
  { label: "Our story", to: "/about", image: "/img/about-home.jpg", tone: "blue" },
  { label: "Shop", to: "/shop", image: "/img/terms-objects.jpg", tone: "gold" },
];

function Main() {
  const [failedImages, setFailedImages] = useState([]);

  return (
    <main
      id="main-content"
      className="home-main"
      style={{
        backgroundImage:
          'linear-gradient(rgba(5, 8, 10, 0.38), rgba(5, 8, 10, 0.58)), url("/img/home-hero.jpg")',
      }}
    >
      <h1 className="sr-only">{siteConfig.brandName} — home and lifestyle collection</h1>
      <div className="home-main__links">
        {homeLinks.map((item) => {
          const failed = failedImages.includes(item.image);

          return (
            <Link
              className={`home-entry home-entry--${item.tone}`}
              key={item.label}
              to={item.to}
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            >
              <span className={`home-entry__image${failed ? " image-fallback" : ""}`}>
                {!failed && (
                  <img
                    src={item.image}
                    alt={`${item.label} at ${siteConfig.brandName}`}
                    width="1120"
                    height="1400"
                    decoding="async"
                    loading={item.label === "Collections" ? "eager" : "lazy"}
                    onError={() =>
                      setFailedImages((items) =>
                        items.includes(item.image) ? items : [...items, item.image]
                      )
                    }
                  />
                )}
              </span>
              <span className="home-entry__label">{item.label}</span>
            </Link>
          );
        })}
      </div>
    </main>
  );
}

export default Main;
